module.exports = "../images/icons-race-details/Phone.svg";